import { render, staticRenderFns } from "./AGM.vue?vue&type=template&id=a0fee570&scoped=true&"
import script from "./AGM.vue?vue&type=script&lang=js&"
export * from "./AGM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fee570",
  null
  
)

export default component.exports